import type { DocumentData, DocumentReference } from 'firebase/firestore'
import { EmployeeModel } from './EmployeeModel'

export class OwnerModel extends EmployeeModel {
  isOwner: boolean
  hidden: boolean

  constructor(data: Partial<OwnerModel>, reference?: DocumentReference) {
    super(
      data,
      reference,
    )
    this.isOwner = data.isOwner || false
    this.hidden = data.hidden || false
  }

  toMap() {
    return {
      ...super.toMap(),
      isOwner: this.isOwner,
      hidden: this.hidden || false,
    }
  }

  toMapCreate() {
    return {
      ...super.toMapCreate(),
      isOwner: this.isOwner,
      hidden: this.hidden || false,
    }
  }
}

export class ManagerModel extends EmployeeModel {}

export function mapManagers(manager: DocumentData) {
  return new ManagerModel(
    manager.data(),
    manager.ref,
  )
}
